export interface OutOfStockResponse {
    success: boolean;
    code: string;
    msg: string;
    data: boolean;
}

export enum SubscribeType {
    OutOfStock = 0,
}